export default __webpack_public_path__ + "static/media/4.cf6c385c.png";